// extracted by mini-css-extract-plugin
export var checkboxInputRow = "D_t0";
export var checkboxInputColumn = "D_t1";
export var inputOptionRow = "D_qq";
export var inputOptionColumn = "D_qr";